import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_of_the_above_6'

export const dataPointDefinition = {
  retracedId: 'none_of_the_above_6',
  name: 'None of the above',
  description:
    'Select "X" for None of the above if the facility HAS a minimum of all measures described, i.e. deductions are voluntarily accepted, workers give written consent, etc.',
  meta: {
    slcpMeta: {
      key: 'wb-wage-104x',
      number: 'WB-WAGE-121-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wb-wage-99',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],wb-19,Yes',
      machineShowHide: '[2],wb-19,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-104x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35940,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
